<template>
  <div class="dialog-content">
    <p>
      Wählen Sie die Layer, die importiert werden sollen
    </p>

    <div v-for="element in getElements" :key="element.name">
      <div class="formItem formCheckbox">
        <checkbox
          :value="isSelected(element)"
          @input="changeSelected(element)"
          :label="element.title"
        >
          {{ element.title }}
        </checkbox>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'Wms',
    props: {
      message: {
        type: String
      },
      value: {
        type: [Object]
      },
      elements: {
        type: Array,
        required: true
      },
      layers: {
        type: Array
      }
    },
    data () {
      return {
        localValue: []
      }
    },
    methods: {
      isSelected (element) {
        const index = this.localValue.findIndex((el) => el.name === element.name)

        return index !== -1
      },
      changeSelected (value) {
        const name = value.name
        const index = this.localValue.findIndex(el => {
          return el.name === name
        })
        if (index !== -1) {
          this.localValue.splice(index, 1)
        } else {
          this.localValue.push(value)
        }
      },
      getData () {
        return this.localValue
      }
    },
    computed: {
      getElements () {
        let wmsLayers = this.layers.filter((layer) => layer.type === 'wms')
        _.differenceWith(this.elements, wmsLayers, (element, layer) => element.name !== layer.title)
        return _.differenceWith(this.elements, wmsLayers, (element, layer) => element.name === layer.title)
      }
    }
  }
</script>

<style scoped>

</style>
